import { useChatStore } from '@@/stores/useChatStore'
export default defineNuxtPlugin({
  name: 'chat-init',
  dependsOn: ['pinia-persist'],
  async setup() {
    console.log('[Chat Init Plugin] Initializing chat store from database...')
    
    // Initialize the chat store from database when the app starts
    // This ensures we always load from database, never from localStorage
    try {
      const chatStore = useChatStore()
      
      // Force initialization from database
      const success = await chatStore.initializeFromDatabase()
      
      if (success) {
        console.log('[Chat Init Plugin] Chat store initialized successfully from database')
      } else {
        console.warn('[Chat Init Plugin] Chat store initialization failed, using empty state')
      }
    } catch (error) {
      console.error('[Chat Init Plugin] Failed to initialize chat store:', error)
      // Don't block the app if initialization fails
    }
  }
})
